import { LogoSGOSTU } from 'common/Logos/Logo-SGOSTU';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SOCIAL_NETWORKS } from 'constants/socialNetworks';
import { useContent } from 'hooks/useContent';
import './Footer.css';
import { useLanguage } from 'hooks/useLanguage';

const OFFER_DOC =
  '/uploads/Zagalni_umovi_platformi_DDB_1_b4230660d0.pdf?updated_at=2025-08-23T21:34:14.731Z';
const PRIVACY_DOC =
  '/uploads/Politika_konfidenczijnosti_DDB_1_eecaaaef4d.pdf?updated_at=2025-08-23T21:34:14.686Z';

export default function Footer() {
  const year = new Date().getFullYear();
  const language = useLanguage();
  const apiBase = process.env.REACT_APP_BASE_API_URL || '';
  // Контакти редагуються в CMS (api::contact-info) — ADR-0017. Незаповнений
  // запис віддає null, тому кожен блок нижче рендериться лише тоді, коли
  // відповідне поле справді прийшло.
  const { data: contactInfo } = useContent('contactInfo');
  const phones = contactInfo?.phones || [];
  const socials = contactInfo?.socials || [];

  return (
    <footer className='footer'>
      <div className='container footer-inner'>
        <div className='footer-brand'>
          <div className='footer-mark'>
            <span className='footer-mark-badge'>
              <LogoSGOSTU classname='footer-logo' />
            </span>
            <span className='footer-mark-name'>{language === 'en' ? 'SGOSTU' : 'СГОСТУ'}</span>
          </div>
          <p className='footer-org'>
            {language === 'en'
              ? 'Dancesport public organisations union of Ukraine'
              : 'Спілка громадських організацій спортивного танцю України'}
          </p>
        </div>

        <nav className='footer-columns' aria-label={language === 'en' ? 'Footer' : 'Підвал сайту'}>
          <div className='footer-column'>
            <h2 className='footer-subtitle'>{language === 'en' ? 'Sections' : 'Розділи'}</h2>
            <Link to='/news'>{language === 'en' ? 'News' : 'Новини'}</Link>
            <Link to='/calendar'>{language === 'en' ? 'Calendar' : 'Календар'}</Link>
            <Link to='/catalogs'>{language === 'en' ? 'Registers' : 'Реєстри'}</Link>
            <Link to='/documents'>{language === 'en' ? 'Documents' : 'Документи'}</Link>
            <Link to='/management'>{language === 'en' ? 'Management' : 'Керівництво'}</Link>
          </div>

          <div className='footer-column'>
            <h2 className='footer-subtitle'>{language === 'en' ? 'Contacts' : 'Контакти'}</h2>
            {phones.map((phone) => (
              <a className='tnum' href={`tel:${phone.number.replace(/[^\d+]/g, '')}`} key={phone.id ?? phone.number}>
                {phone.number}
              </a>
            ))}
            {contactInfo?.email && <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>}
            {contactInfo?.addressText && (
              <a href={contactInfo.addressUrl || undefined} target='_blank' rel='noreferrer'>
                {contactInfo.addressText}
              </a>
            )}
          </div>

          <div className='footer-column'>
            <h2 className='footer-subtitle'>{language === 'en' ? 'Documents' : 'Правові документи'}</h2>
            <a href={`${apiBase}${OFFER_DOC}`} target='_blank' rel='noreferrer'>
              {language === 'en' ? 'Terms of the offer' : 'Договір оферти'}
            </a>
            <a href={`${apiBase}${PRIVACY_DOC}`} target='_blank' rel='noreferrer'>
              {language === 'en' ? 'Privacy policy' : 'Політика конфіденційності'}
            </a>
            <Link to='/logos'>{language === 'en' ? 'Logos and brand files' : 'Логотипи та фірмові файли'}</Link>
          </div>

          <div className='footer-column'>
            <h2 className='footer-subtitle'>{language === 'en' ? 'Social networks' : 'Соціальні мережі'}</h2>
            <div className='footer-social'>
              {socials.map((social) => {
                const meta = SOCIAL_NETWORKS[social.network];
                if (!meta) return null;

                return (
                  <a
                    href={social.url}
                    target='_blank'
                    rel='noreferrer'
                    aria-label={meta.label}
                    key={social.id ?? social.network}
                    style={{ '--social-hover': meta.hoverColor }}
                  >
                    <FontAwesomeIcon icon={meta.icon} />
                  </a>
                );
              })}
            </div>
          </div>
        </nav>
      </div>

      <div className='container footer-bottom'>
        <span className='copyright'>
          © {year} {language === 'en' ? 'SGOSTU' : 'СГОСТУ'}
        </span>
        <a href='https://sate.team' target='_blank' rel='noreferrer' className='authors'>
          By Sate
        </a>
      </div>
    </footer>
  );
}
